import { render, staticRenderFns } from "./Communicate.vue?vue&type=template&id=1000b318&scoped=true"
import script from "./Communicate.vue?vue&type=script&lang=js"
export * from "./Communicate.vue?vue&type=script&lang=js"
import style0 from "./Communicate.vue?vue&type=style&index=0&id=1000b318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1000b318",
  null
  
)

export default component.exports